import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import inboundSubmissionsReducer from '../reducers/inboundSubmissionsReducer';

const configureStore = (railsProps) => (
  createStore(inboundSubmissionsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
